/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_AccountsInputs */

const da_admin_nav_accounts = /** @type {(inputs: Admin_Nav_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konti og mails`)
};

/** @type {(inputs: Admin_Nav_AccountsInputs) => LocalizedString} */
const en_admin_nav_accounts = da_admin_nav_accounts;

/**

* @param {Admin_Nav_AccountsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_accounts = /** @type {((inputs?: Admin_Nav_AccountsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_AccountsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_accounts(inputs)
	return /** @type {LocalizedString} */ ("Konti og mails")
});